import React from "react";

import * as Styled from "./leasing-banner-flex.styled";
import { LeasingModals } from "../../../../contexts/leasing/types/leasing.types";
import { useTracking } from "../../../../utils/tracking/use-tracking";
import {
  BannerItemButton,
  BannerItemLink,
  BannerItemText,
} from "../leasing-banner.styled";
import { LeasingBannerLayoutProps } from "../leasing-banner.types";

export const BannerFlex = ({
  handleOpenModal,
  bannerData,
}: LeasingBannerLayoutProps) => {
  const { trackEvent } = useTracking();

  return (
    <Styled.BannerInner>
      {bannerData.map((item, itemIndex) => {
        return (
          <Styled.BannerItem key={itemIndex}>
            {item.link ? (
              <BannerItemLink
                href={item.link}
                onClick={() => trackEvent({ trackingLabel: item.tracking })}
              >
                {item.icon}
                <BannerItemText aria-describedby="required-description">
                  {item.text}
                </BannerItemText>
              </BannerItemLink>
            ) : (
              <BannerItemButton
                onClick={() => {
                  handleOpenModal({
                    type: item?.modal ?? LeasingModals.NONE,
                    title: item.title,
                    tracking: item.tracking,
                  });
                }}
              >
                {item.icon}
                <BannerItemText aria-describedby="required-description">
                  {item.text}
                </BannerItemText>
              </BannerItemButton>
            )}
          </Styled.BannerItem>
        );
      })}
    </Styled.BannerInner>
  );
};
